<template>
    <div class="insurer-code-container">
        <ul>
            <li v-for="insurer in insurer.insurerCodes" :key="insurer._uid">
                <typo name="body-14-normal">
                    {{ getInsurerLabel(insurer) }}
                </typo>
            </li>
        </ul>
        <typo v-if="insurer.startDate" name="body-14-normal">
            Date de début: {{ formatDate(insurer.startDate) }}
        </typo>
        <typo v-if="insurer.expiryDate" name="body-14-normal">
            Date d'expiration: {{ formatDate(insurer.expiryDate) }}
        </typo>
        <badge v-if="insurer.insuranceType && getInsuranceType(insurer.insuranceType) !== ''">
            {{ getInsuranceType(insurer.insuranceType) }}
        </badge>
    </div>
</template>

<script>
import { get, upperFirst } from "lodash";
import { Services } from "src/services/Services";
import Badge from "src/components/convention/vision-panorama/common/Badge.vue";

export default {
    components: { Badge },
    props: ["insurer", "insurers", "annotationOptions"],
    methods: {
        getInsurerLabel(insurerCode) {
            return get(this.insurers, `${insurerCode}.label`, "");
        },
        getInsuranceType(insuranceType) {
            const type = get(this.annotationOptions, `${insuranceType}.label`, "").toLowerCase();
            return upperFirst(type);
        },
        formatDate(date) {
            const isDate = Services.moment(date).isValid();
            return isDate ? Services.moment(date).format("DD/MM/YYYY") : "";
        },
    },
    computed: {
        insurerTypes() {
            return this.$privateDico.convention.annotations.insurerTypes;
        },
    },
};
</script>

<style scoped lang="sass">
.insurer-code-container
    display: flex
    flex-direction: column
    width: 250px
    margin: 0 16px
    padding: 0 16px
</style>
